module.exports = __webpack_public_path__ + "img/cf.72280fc1.jpg";